import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import '../src/assets/css/_reset.css'
import Vant from 'vant';
import 'vant/lib/index.css';
// import Vconsole from '@/libs/commonjs/vconsole.min.js';
// let vConsole = new Vconsole()
// Vue.use(vConsole)
Vue.config.productionTip = false
Vue.use(Vant);
new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
